/* eslint-disable import/no-cycle */
import AuthStore from './AuthStore';
import JourneyStore from './JourneyStore';

/**
 * @class RootStore
 * @description A combination of all stores in the application.
 */
class RootStore implements RootStore {
  private authStore: AuthStore | null = null;

  private journeyStore: JourneyStore | null = null;

  /**
   * @method getAuthStore
   *
   */
  get getAuthStore(): AuthStore {
    if (this.authStore === null) {
      this.authStore = new AuthStore(this);
    }
    return this.authStore;
  }

  /**
   * @method getJourneyStore
   *
   */
  get getJourneyStore(): JourneyStore {
    if (this.journeyStore === null) {
      this.journeyStore = new JourneyStore(this);
    }
    return this.journeyStore;
  }
}

export default RootStore;
